import { render, staticRenderFns } from "./PlayerAndTeamSelectionView.vue?vue&type=template&id=a0b2b300&scoped=true&"
import script from "./PlayerAndTeamSelectionView.vue?vue&type=script&lang=ts&"
export * from "./PlayerAndTeamSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerAndTeamSelectionView.vue?vue&type=style&index=0&id=a0b2b300&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b2b300",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
